import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { CloudUpload, Loader2 } from "lucide-react";

// V1.95 · Sube a Cloud/OneDrive los contratos, autorizaciones y docs DGT firmados que falten.
export default function SyncSignedButton({ studentId, onDone }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/contracts/backfill-signed-expediente", null, {
        params: { limit: 500, ...(studentId ? { student_id: studentId } : {}) },
      });
      const failed = data.failed?.length || 0;
      const msg = `Sincronizados: ${data.pushed_count} subidos · ${data.skipped} ya estaban${failed ? ` · ${failed} con error` : ""}`;
      (failed ? toast.warning : toast.success)(msg);
      onDone?.();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Error al sincronizar");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      onClick={run}
      disabled={busy}
      data-testid={studentId ? "sync-signed-student-btn" : "sync-signed-all-btn"}
      title="Sube a Cloud/OneDrive los documentos firmados que falten"
      className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700 disabled:opacity-60 transition-colors"
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CloudUpload className="h-3.5 w-3.5" />}
      {busy ? "Sincronizando…" : "Sincronizar firmados"}
    </button>
  );
}
